var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-theme-provider',{attrs:{"dark":_vm.dark}},[_c('div',[_c('base-info-card',{attrs:{"title":_vm.title,"pace":"6"}},[_c('div',{staticClass:"text-justify"},[_vm._v(_vm._s(_vm.text))])])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }